import { gql } from "@apollo/client";

export const CHANGE_PASSWORD = gql`
mutation ChangePass($currentPassword: String!, $newPassword: String!, $confirmNewPassword: String!){
    changePassword( currentPassword:$currentPassword, newPassword:$newPassword, confirmNewPassword:$confirmNewPassword){
        status
    }
}`